import {
  setAttribute
} from "./DJESYNLE.js";
import {
  walkTreeOutside
} from "./ISPCL6N4.js";

// src/dialog/utils/disable-accessibility-tree-outside.ts
function hideElementFromAccessibilityTree(element) {
  return setAttribute(element, "aria-hidden", "true");
}
function disableAccessibilityTreeOutside(...elements) {
  const cleanups = [];
  walkTreeOutside(elements, (element) => {
    cleanups.unshift(hideElementFromAccessibilityTree(element));
  });
  const restoreAccessibilityTree = () => {
    cleanups.forEach((fn) => fn());
  };
  return restoreAccessibilityTree;
}

export {
  hideElementFromAccessibilityTree,
  disableAccessibilityTreeOutside
};
